export default function DropdownArrowIcon({ className = "", onClick = null }) {
  return (
    <svg
      className={className}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 500 500"
    >
      <path d="M250,358.57c-6.95,0-13.89-2.65-19.19-7.95L67.95,187.76c-10.6-10.6-10.6-27.79,0-38.39,10.6-10.6,27.79-10.6,38.39,0l143.66,143.66,143.66-143.66c10.6-10.6,27.79-10.6,38.39,0,10.6,10.6,10.6,27.79,0,38.39l-162.86,162.86c-5.3,5.3-12.25,7.95-19.19,7.95Z"/>
    </svg>
  );
}
